import type { DefaultObject } from '@moniebook-web/types';
import { getBaseService } from '@moniebook-web/utils';

const serviceUrl: DefaultObject = {
    MONIEBOOK_ACCOUNT_URL:
        process.env.MONIEBOOK_ACCOUNT_URL ?? 'https://moniebook.moniepoint.com',

    MONIEBOOK_PRIVACY_POLICY_URL:
        process.env.MONIEBOOK_PRIVACY_POLICY_URL ??
        'https://moniepoint.com/privacy_policy',

    MONIEBOOK_TERMS_URL:
        process.env.MONIEBOOK_TERMS_URL ??
        'https://moniebook.moniepoint.com/terms-and-conditions',

    APP_VERSION: process.env.APP_VERSION ?? '0.0.0',

    PRINT_AGENT_BASE_URL:
        process.env.PRINT_AGENT_BASE_URL ?? 'http://localhost:49898',
};

const getService = getBaseService(serviceUrl);

type RuntimeConfig = Record<string, string | undefined>;

type WindowWithConfig = Global & {
    inject?: {
        CONFIG: RuntimeConfig;
    };
};
const windowConfig = (globalThis as WindowWithConfig).inject?.CONFIG;

export const GLOBAL_CONFIG = {
    MONIEBOOK_SERVICE_URL:
        windowConfig?.MONIEBOOK_SERVICE_URL ??
        import.meta.env.VITE_MONIEBOOK_SERVICE_URL,
    ORDER_SERVICE_URL:
        windowConfig?.ORDER_SERVICE_URL ??
        import.meta.env.VITE_ORDER_SERVICE_URL,
    ENVIRONMENT: windowConfig?.ENVIRONMENT ?? import.meta.env.VITE_ENVIRONMENT,
    ENABLE_ANALYTICS:
        windowConfig?.ENABLE_ANALYTICS ?? import.meta.env.VITE_ENABLE_ANALYTICS,
    ENABLE_MONITORING:
        windowConfig?.ENABLE_MONITORING ??
        import.meta.env.VITE_ENABLE_MONITORING,
} as const;

export const config = {
    MONIEBOOK_ACCOUNT_URL: getService('MONIEBOOK_ACCOUNT_URL'),
    MONIEBOOK_PRIVACY_POLICY_URL: getService('MONIEBOOK_PRIVACY_POLICY_URL'),
    MONIEBOOK_TERMS_URL: getService('MONIEBOOK_TERMS_URL'),
    APP_VERSION: getService('APP_VERSION'),
    PRINT_AGENT_BASE_URL: getService('PRINT_AGENT_BASE_URL'),
};
